import axios from '../utils/axios'
let recordApi={
    // 分页获取提醒信息
    getRecordInfo(params, success){
        axios('/record/getrecordinfo', params, success)
    },
    //新增提醒
    addRecord(params, success){
        axios('/record/addrecord', params, success)
    },
    //修改提醒
    updateRecord(params, success){
        axios('/record/updaterecord', params, success)
    },
    //删除提醒
    deleteRecord(params, success){
        axios('/record/deleterecord', params, success)
    }
}
export default recordApi


// WEBPACK FOOTER //
// ./src/api/record.js